import { get, post, del, publicGet, publicPost } from './core';
import type {
  CoDirectorListResponse,
  CoDirectorPoolEntry,
  CoDirectorInvitePreview,
  InviteCoDirectorResponse,
  ClaimInviteAccountResponse,
} from '@swiss-magic/shared-types';

// Story 094 — co-director management (owner-only) + the public accept flow.

export function listCoDirectors(
  tournamentId: string,
): Promise<CoDirectorListResponse> {
  return get(`/tournaments/${tournamentId}/co-directors`);
}

export function getCoDirectorPool(
  tournamentId: string,
): Promise<CoDirectorPoolEntry[]> {
  return get(`/tournaments/${tournamentId}/co-directors/pool`);
}

export function inviteCoDirector(
  tournamentId: string,
  email: string,
  locale?: string,
): Promise<InviteCoDirectorResponse> {
  return post(`/tournaments/${tournamentId}/co-directors/invites`, {
    email,
    locale,
  });
}

export function revokeCoDirectorInvite(
  tournamentId: string,
  inviteId: string,
): Promise<{ ok: true }> {
  return del(`/tournaments/${tournamentId}/co-directors/invites/${inviteId}`);
}

export function resendCoDirectorInvite(
  tournamentId: string,
  inviteId: string,
): Promise<{ ok: true }> {
  return post(
    `/tournaments/${tournamentId}/co-directors/invites/${inviteId}/resend`,
  );
}

export function addCoDirectorFromPool(
  tournamentId: string,
  directorUserId: string,
): Promise<{ ok: true }> {
  return post(`/tournaments/${tournamentId}/co-directors`, { directorUserId });
}

export function removeCoDirector(
  tournamentId: string,
  userId: string,
): Promise<{ ok: true }> {
  return del(`/tournaments/${tournamentId}/co-directors/${userId}`);
}

// --- Accept flow (public) ---

export function previewCoDirectorInvite(
  token: string,
): Promise<CoDirectorInvitePreview> {
  return publicGet(`/co-director-invite/${token}/preview`);
}

export function claimCoDirectorAccount(
  token: string,
  password: string,
): Promise<ClaimInviteAccountResponse> {
  return publicPost(`/co-director-invite/${token}/claim-account`, { password });
}

export function acceptCoDirectorInvite(
  token: string,
): Promise<{ tournamentId: string }> {
  return post(`/co-director-invite/${token}/accept`);
}
